<template>
	<PayUnlockShell v-bind="shellProps" stack-action @select="$emit('select')">
		<template #left>
			<PayIcon icon="mystery" color="#fff" :bg="btnColor" :h5="h5" />
		</template>
		<template #info>
			<p class="g-block-pay-unlock__title">{{ data.title || '剩余内容已隐藏' }}</p>
			<p class="g-block-pay-unlock__desc">{{ data.subtitle || '解锁后可查看全部' }}</p>
		</template>
		<template #action>
			<span class="g-block-pay-unlock__price g-block-pay-unlock__price--sm" :style="priceColor">¥ {{ displayPrice }}</span>
			<PayUnlockButton
				:text="data.buttonText || '继续探索'"
				:style="buttonStyle"
				@click="onButtonClick"
			/>
		</template>
	</PayUnlockShell>
</template>

<script>
	import PayUnlockShell from '../shared/PayUnlockShell.vue';
	import PayUnlockButton from '../shared/PayUnlockButton.vue';
	import PayIcon from '../shared/PayIcon.vue';
	import { payUnlockMixin } from '../shared/mixin.js';
	import { formatPayPrice, getButtonColor } from '../shared/utils.js';
	import { DEFAULT_PAY_UNLOCK_MYSTERY } from '../../../templates.js';

	export default {
		name: 'GBlockPayUnlockMystery',
		components: { PayUnlockShell, PayUnlockButton, PayIcon },
		mixins: [payUnlockMixin],
		computed: {
			defaultButtonColors() {
				return DEFAULT_PAY_UNLOCK_MYSTERY;
			},
			btnColor() {
				return getButtonColor(this.data, DEFAULT_PAY_UNLOCK_MYSTERY);
			},
			priceColor() {
				return { color: this.btnColor };
			},
			shellProps() {
				return {
					data: this.data,
					editable: this.editable,
					active: this.active,
					fixedBottom: this.fixedBottom,
					h5: this.h5,
					stackAction: true,
				};
			},
			displayPrice() {
				return formatPayPrice(this.data.price);
			},
		},
	};
</script>
